module.exports = __webpack_public_path__ + "img/85.59a4bba2.png";